import type { ComponentTypeUnionType } from '@unifyapps/defs/types/block';
import { useMemo } from 'react';
import { useRegistryContext } from '../components/RegistryProvider';

function useGetBlockBehavior(componentType?: ComponentTypeUnionType) {
  const { registry } = useRegistryContext();
  return useMemo(() => {
    if (!componentType) return;
    return registry.getBlockBehavior(componentType);
  }, [componentType, registry]);
}

export default useGetBlockBehavior;
